// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__C7yXI","label":"styles_label__944ek","title":"styles_title__b7WzA","text":"styles_text__Elt6D","chips":"styles_chips__OgnkQ","chip":"styles_chip__Vo988"};